// src/userComponent/AdminProfile.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../css/UserProfile.css"; // reuse same CSS as UserProfile

const AdminProfile = () => {
  const navigate = useNavigate();
  const admin = JSON.parse(sessionStorage.getItem("active-admin"));

  if (!admin) {
    return (
      <div className="auth-background">
        <div className="container mt-5">
          <div className="alert alert-warning text-center">
            Please login to view your profile.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-background py-4">
      <div className="container">
        <div className="profile-card shadow-lg">
          <div className="profile-header d-flex align-items-center justify-content-between">
            <div>
              <h2 className="mb-0">Admin Profile</h2>
              <div className="small text-muted">
                Manage your account details
              </div>
            </div>

            <div className="header-actions"></div>
          </div>

          <div className="profile-body p-4">
            <div className="row gx-4 align-items-center">
              <div className="col-md-3 text-center">
                <div className="avatar-wrapper mx-auto mb-2">
                  {admin.firstName || admin.lastName ? (
                    <div className="avatar-initials">
                      {(admin.firstName || "A").charAt(0).toUpperCase()}
                      {(admin.lastName || "").charAt(0).toUpperCase()}
                    </div>
                  ) : (
                    <img
                      src="/assets/default-avatar.png"
                      alt="avatar"
                      className="avatar-img"
                    />
                  )}
                </div>

                <div className="mt-2">
                  <div className="fw-600">{`${admin.firstName || ""} ${
                    admin.lastName || ""
                  }`}</div>
                  <div className="small text-muted">
                    {admin.role || "Admin"}
                  </div>
                </div>
              </div>

              <div className="col-md-9">
                <div className="row">
                  <div className="col-sm-6 mb-3">
                    <div className="label">Email</div>
                    <div className="value">{admin.emailId || "-"}</div>
                  </div>

                  <div className="col-sm-6 mb-3">
                    <div className="label">Phone</div>
                    <div className="value">{admin.phoneNo || "-"}</div>
                  </div>

                  <div className="col-sm-6 mb-3">
                    <div className="label">Full Name</div>
                    <div className="value">{`${admin.firstName || ""} ${
                      admin.lastName || ""
                    }`}</div>
                  </div>

                  <div className="col-sm-6 mb-3">
                    <div className="label">Role</div>
                    <div className="value">{admin.role || "-"}</div>
                  </div>
                </div>

                {/* Address block (if available) */}
                {admin.address ||
                (admin.deliveryAddresses &&
                  admin.deliveryAddresses.length > 0) ? (
                  <div className="mt-3">
                    <h6 className="mb-2">Address</h6>

                    {admin.address ? (
                      <div className="address-card p-3 mb-2">
                        <div className="small text-muted">
                          {admin.address.street}
                        </div>
                        <div className="small text-muted">
                          {admin.address.city}, {admin.address.pincode}
                        </div>
                      </div>
                    ) : null}

                    {admin.deliveryAddresses &&
                      admin.deliveryAddresses.length > 0 && (
                        <div className="d-flex gap-2 flex-wrap">
                          {admin.deliveryAddresses.map((a) => (
                            <div key={a.id} className="address-pill p-2">
                              <div className="small text-muted">
                                {a.downtown}
                              </div>
                              <div className="small">{a.city}</div>
                            </div>
                          ))}
                        </div>
                      )}
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          <div className="profile-footer p-3 text-muted small text-end">
            <div>
              Profile last updated:{" "}
              {admin.updatedAt
                ? new Date(Number(admin.updatedAt)).toLocaleString()
                : "-"}
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default AdminProfile;
